import type { i18n as I18n } from 'i18next'

/**
 * Keeps `<html lang>` equal to the i18next UI language.
 *
 * index.html ships `lang="en"` and nothing updated it afterwards, so a user
 * running the UI in Finnish still told the browser the page was English —
 * one of the cues Chrome uses to offer translating the page, which is how
 * translated icon ligature names reached the DOM. The attribute also drives
 * screen-reader pronunciation and hyphenation.
 *
 * Returns a function that stops following language changes.
 */
export function syncDocumentLanguage(i18n: I18n, doc: Document = document): () => void {
  const apply = (lng: string) => {
    if (lng) doc.documentElement.lang = lng
  }
  apply(i18n.language)
  i18n.on('languageChanged', apply)
  return () => i18n.off('languageChanged', apply)
}
